import React from "react";
import { Box, Tooltip } from "@mui/material";

export const PremiumSettingLabel: React.FC<{
    label: React.ReactNode;
    locked: boolean;
}> = ({ label, locked }) => (
    <Box
        component="span"
        sx={{ display: "inline-flex", alignItems: "center", gap: 1 }}
    >
        <Box
            component="span"
            sx={{ color: locked ? "text.disabled" : "inherit" }}
        >
            {label}
        </Box>
        {locked && (
            <span
                role="img"
                aria-label="premium"
                style={{ fontSize: "12px", lineHeight: 1 }}
            >
                ⭐️
            </span>
        )}
    </Box>
);

export const LockedSetting: React.FC<{
    locked: boolean;
    tooltip: string;
    children: React.ReactNode;
}> = ({ locked, tooltip, children }) => {
    if (!locked) {
        return <>{children}</>;
    }

    return (
        <Tooltip title={tooltip} placement="top" arrow enterTouchDelay={0}>
            <Box
                component="div"
                sx={{
                    display: "block",
                    cursor: "not-allowed",
                    "& .MuiTypography-root, & .MuiFormControlLabel-label": {
                        color: "text.disabled",
                    },
                    "& .MuiSwitch-root, & .MuiCheckbox-root, & .MuiInputBase-root, & .MuiIconButton-root":
                        {
                            pointerEvents: "none",
                        },
                    "& .MuiSwitch-root, & .MuiCheckbox-root, & .MuiInputBase-root":
                        {
                            opacity: 0.55,
                        },
                }}
            >
                {children}
            </Box>
        </Tooltip>
    );
};
